export default __webpack_public_path__ + "static/media/calltoaction.bed5d864.png";